/**
 * Created by Sebastian Sprenger
 * @since 02.07.2025
 */
import config from '@src/js/config';
import { fetchWithAuth } from '@src/js/utils/http';
const BASE_URL = `${config.API_URL}organisations`;
export class OrganisationService {
    static async getAll() {
        const res = await fetchWithAuth(BASE_URL);
        if (!res.ok) {
            throw new Error(`Failed to load organisations. Status: ${res.status}`);
        }
        const json = await res.json();
        return json.organisations;
    }
    static async getById(id) {
        const res = await fetchWithAuth(`${BASE_URL}/${id}`);
        if (!res.ok) {
            throw new Error(`Organisation not found (ID: ${id})`);
        }
        const json = await res.json();
        return json.organisation;
    }
    static async save(org) {
        const res = await fetchWithAuth(BASE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(org),
        });
        if (!res.ok) {
            const error = await res.json();
            throw new Error(error?.details || 'Failed to save organisation');
        }
        const json = await res.json();
        return json.organisation;
    }
    static async delete(id) {
        const url = `${BASE_URL}?id=${id}`;
        const res = await fetchWithAuth(url, { method: 'DELETE' });
        if (!res.ok) {
            throw new Error(`Failed to delete organisation ID ${id}`);
        }
    }
}
